Bingo.ContractLetAgreementMultiStepForm = {};

Bingo.ContractLetAgreementMultiStepForm.calculateDepositMonthly = () => {
    const depositType = this.depositType.filter(':checked');
    if (depositType.val() === 'count') {
        this.depositAmount.closest('.A-textField').addClass('-disabled');
        if (this.chargesMonthly.val() !== '') {
            const calculated = parseInt(this.chargesMonthly.filter('[type=hidden]').val()) * parseInt(this.depositCount.val());
            this.depositAmount.val(calculated).change();
            this.depositAmount.each(function () {
                const anElement = AutoNumeric.getAutoNumericElement(this);
                if (anElement !== null) {
                    anElement.set(calculated);
                }
            });
        } else {
            this.depositAmount.val('').change();
        }
    } else {
        this.depositAmount.closest('.A-textField').removeClass('-disabled');
    }
};

Bingo.ContractLetAgreementMultiStepForm.initPricingTermsForm = () => {
    this.rentMonthly = $('.js-input-rentMonthly');
    this.commissionAmount = $('.js-input-commissionAmount');
    this.commissionType = $('.js-input-commissionType');
    this.commissionMonthCount = $('.js-input-commissionMonthCount');
    this.agreedCommission = $('.js-input-agreedCommission');
    this.chargesMonthly = $('.js-input-chargesMonthly');
    this.depositAmount = $('.js-input-depositAmount');
    this.depositCount = $('.js-input-depositCount');
    this.depositType = $('.js-input-depositType');

    this.chargesMonthly.change(() => {
        Bingo.ContractLetAgreementMultiStepForm.calculateDepositMonthly();
    });
    this.depositCount.change(() => {
        Bingo.ContractLetAgreementMultiStepForm.calculateDepositMonthly();
    });
    this.depositType.change(() => {
        Bingo.ContractLetAgreementMultiStepForm.calculateDepositMonthly();
    });

    Bingo.ContractLetAgreementMultiStepForm.calculateDepositMonthly();
};
